module.exports = __webpack_public_path__ + "static/img/103451.0c4588b8.png";